import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { resolveNavIconForPath } from "@/utils/pageNavIcon";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

function displayBreadcrumbLabel(label: string): string {
  if (label === 'Human') return 'HR';
  return label;
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav className="flex items-center gap-1 text-sm text-slate-500">
      {items.map((item, i) => {
        const Icon = item.to ? resolveNavIconForPath(item.to.split("#")[0]) : null;
        const isLast = i === items.length - 1;

        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1">
            {i > 0 && <NavigateNextIcon sx={{ fontSize: 16 }} />}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="flex items-center gap-1 hover:text-primary-600"
              >
                {Icon ? (
                  <Icon sx={{ fontSize: 14 }} className="opacity-80" />
                ) : null}
                {displayBreadcrumbLabel(item.label)}
              </Link>
            ) : (
              <span
                className={`flex items-center gap-1 ${isLast ? "font-medium text-slate-800 dark:text-slate-200" : ""}`}
              >
                {Icon ? (
                  <Icon sx={{ fontSize: 14 }} className="opacity-80" />
                ) : null}
                {displayBreadcrumbLabel(item.label)}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
